import React from 'react';
// images
import heroImageDesktopWebp from './images/family-at-the-beach-desktop.webp';
import heroImageMobileWebp from './images/family-at-the-beach-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='fixed-variable-annuities-hero'
      productName='Fixed &#38; Variable Annuities'
      headingText='Retirement savings: check.'
      descriptionText={<>Let us help make sure you can retire worry free. A fixed or variable deferred annuity, also known as an accumulation annuity, is like your 401(k) or IRA. You can save money tax&#45;deferred that you can use as an extra source of income in retirement.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get started',
        ariaLabel: 'Get annuities with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='family having fun together on an ocean beach at sunset'
      backgroundImageDesktop={heroImageDesktopWebp.toString()}
      backgroundImageMobile={heroImageMobileWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );
};
